import './selection.css'

export function Selection({ text, name, options, handleOnChange, value }) {
    return (
        <div className='form_control'>
            <label className='select_label' htmlFor={name}>
                {text}
            </label>
            
            <div className='select_wrapper'>
                <select
                    required
                    className='select_input'
                    name={name}
                    id={name}
                    onChange={handleOnChange}
                    value={value} // Mantém controlado mesmo se value for undefined
                >
                    <option value="" disabled>
                        Selecione uma opção
                    </option>
                    
                    {options && options.map((option) => (
                        <option value={option.id} key={option.id}> 
                            {option.nome}
                        </option>
                    ))}
                </select>
                
                {/* Ícone de Seta Customizado */}
                <svg 
                    className='select_icon' 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                >
                    <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
            </div>
        </div>
    )
}


